import { CountryCode } from '@carsys/enums/country-code'
import MoneyBillIcon from '@carsys/ui/src/icons/MoneybillIcon'
import { useShopCountry } from '@cbgms/base/shop-country'

export const InvoiceIcon = () => {
  const { countryCode } = useShopCountry()
  return <MoneyBillIcon country={countryCode || CountryCode.NL} />
}
export default InvoiceIcon
